import queryString from 'qs';

export const getPromoListRequest = (queryParams) => {
  const queries = { limit: queryParams?.limit, page: queryParams?.page };

  if (queryParams?.search) queries.search = queryParams?.search;
  if (queryParams?.brand) queries['brand.name'] = `[${queryParams?.brand?.map((brand) => brand.value).join(',')}]`;
  if (queryParams?.statusStock) queries.statusStock = queryParams?.statusStock?.value;
  if (queryParams?.promoStatus) queries.status = `[${queryParams?.promoStatus?.map((status) => status.value).join(',')}]`;
  if (queryParams?.shop) queries['storeName'] = `[${queryParams?.shop?.map((opt) => opt.label).join(',')}]`;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getPromoListRequest;
